import { render, staticRenderFns } from "./hot-product.vue?vue&type=template&id=12b6df69&scoped=true&"
import script from "./hot-product.vue?vue&type=script&lang=js&"
export * from "./hot-product.vue?vue&type=script&lang=js&"
import style0 from "./hot-product.vue?vue&type=style&index=0&id=12b6df69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b6df69",
  null
  
)

export default component.exports